/**
 * STORE PICKUP AVAILABILITY v2
 */
(function () {
  'use strict'; 

  console.log('[v2] Script gestartet');

  const dataEl = document.getElementById('pickup-availability-data');
  console.log('[v2] dataEl:', dataEl);
  if (!dataEl) return;

  let availabilityData;
  try {
    availabilityData = JSON.parse(dataEl.textContent);
    console.log('[v2] JSON parsed, Varianten:', Object.keys(availabilityData));
  } catch (e) {
    console.error('[v2] JSON Parse-Fehler:', e);
    return;
  }

  const el = document.querySelector('pickup-availability');
  console.log('[v2] el:', el);
  if (!el) return;

  const template = el.querySelector('template');
  console.log('[v2] template:', template);

  if (template) {
    const clone = template.content.cloneNode(true);
    const preview = clone.querySelector('pickup-availability-preview');
    const drawerClone = clone.querySelector('pickup-availability-drawer');
    console.log('[v2] preview im clone:', preview);
    console.log('[v2] drawer im clone:', drawerClone);
    if (preview) el.appendChild(preview);
    console.log(
  '[v2] Live-Variantentext nach dem Klonen:',
      el.querySelector('[data-pickup-variant]')
    );
    if (drawerClone) document.body.appendChild(drawerClone);
  }

  const drawer = document.querySelector('pickup-availability-drawer');
  console.log('[v2] drawer im DOM:', drawer);
  if (!drawer) return;

  const ICON_TICK = `<svg class="icon icon-checkmark color-foreground-" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 12 9" fill="none"><path fill-rule="evenodd" clip-rule="evenodd" d="M11.35.643a.5.5 0 01.006.707l-6.77 6.886a.5.5 0 01-.719-.006L.638 4.845a.5.5 0 11.724-.69l2.872 3.011 6.41-6.517a.5.5 0 01.707-.006h-.001z" fill="#00a65a"/></svg>`;
  const ICON_UNAVAILABLE = `<svg class="icon icon-unavailable" aria-hidden="true" focusable="false" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none" style="color: #e22120;">
  <path d="M8 1a7 7 0 100 14A7 7 0 008 1zM0 8a8 8 0 1116 0A8 8 0 010 8z" fill="currentColor"/>
  <path d="M11.354 5.354a.5.5 0 00-.708-.708L8 7.293 5.354 4.646a.5.5 0 10-.708.708L7.293 8l-2.647 2.646a.5.5 0 00.708.708L8 8.707l2.646 2.647a.5.5 0 00.708-.708L8.707 8l2.647-2.646z" fill="currentColor"/>
</svg>`;

/*
  function renderOpeningHours(hoursString) {
    if (!hoursString) return '';
    const days = hoursString.split('//');
    const rows = days.map(day => {
      const parts = day.split('##');
      return `<div>${parts[0]}:</div><div>${parts[1] || ''}</div>`;
    }).join('');
    return `
      <p class="h4" style="margin: 8px 0 5px;">Öffnungszeiten</p>
      <div class="opening-hours-grid">${rows}</div>
    `;
  }
  */

  function updateVariantLabel(variant) {
    const variantLabel = document.querySelector(
      'pickup-availability-drawer [data-pickup-variant]'
    );

    if (!variantLabel || !variant) {
      console.log('[v2] Variantentext im Drawer nicht gefunden');
      return;
    }

    let optionNames;

    try {
      optionNames = JSON.parse(el.dataset.optionNames || '[]');
    } catch (error) {
      console.error('[v2] Optionsnamen konnten nicht gelesen werden:', error);
      return;
    }

    const optionValues = Array.isArray(variant.options)
      ? variant.options
      : [variant.option1, variant.option2, variant.option3]
          .filter((value) => value != null);

    variantLabel.replaceChildren();

    optionNames.forEach((optionName, index) => {
      const optionValue = optionValues[index];
      if (!optionValue) return;

      if (index > 0) {
        variantLabel.append(', ');
      }

      variantLabel.append(`${optionName}: `);

      const valueElement = document.createElement('span');
      valueElement.textContent = optionValue;
      variantLabel.append(valueElement);
    });
  }

  document.addEventListener('change', (event) => {
  console.log('[debug] change:', event.target);
}, true);

  function updateDisplay(variantId) {
    console.log('[v2] updateDisplay für Variante:', variantId);
    const variantData = availabilityData[String(variantId)];
    console.log('[v2] variantData:', variantData);

    if (!variantData || !variantData.has_locations || variantData.locations.length === 0) {
      console.log('[v2] keine Locations → ausblenden');
      el.removeAttribute('available');
      el.style.display = 'none';
      return;
    }

    el.setAttribute('available', '');
    el.style.display = '';

    const list = document.querySelector('[data-store-availability-drawer-content]');
    console.log('[v2] list:', list);
    if (!list) return;

    list.innerHTML = variantData.locations.map(loc => `
      <li class="pickup-availability-list__item">
        <h3 class="h4">${loc.name}</h3>
        <p class="pickup-availability-preview caption-large">
          ${loc.available
            ? `${ICON_TICK} Produkt vorrätig`
            : `${ICON_UNAVAILABLE} Nicht vorrätig.`
          }
        </p>
        <address class="pickup-availability-address">
          ${loc.address || ''}
        </address>
      </li>
    `).join('');

    
    const firstAvailable = variantData.locations.find(loc => loc.available);
    console.log('[v2] firstAvailable:', firstAvailable?.name);
    const summaryLabel = el.querySelector('[data-pickup-summary-label]');
    const summaryTime = el.querySelector('[data-pickup-summary-time]');
    if (firstAvailable && summaryLabel) {
      summaryLabel.textContent = `Produkt bei ${firstAvailable.name} verfügbar`;
    }
    /*
    if (firstAvailable && summaryTime) {
      summaryTime.textContent = firstAvailable.pick_up_time || '';
    }
    */    
  }

  // Button → Drawer öffnen
  document.addEventListener('click', (e) => {
    if (e.target.closest('#ShowPickupAvailabilityDrawer')) {
      if (typeof drawer.show === 'function') {
        drawer.show(e.target);
      } else {
        drawer.removeAttribute('hidden');
        drawer.setAttribute('open', '');
      }
    }
  });

  // Drawer schließen
  drawer.addEventListener('click', (e) => {
    if (e.target.closest('.pickup-availability-drawer-button')) {
      if (typeof drawer.hide === 'function') {
        drawer.hide();
      } else {
        drawer.removeAttribute('open');
        drawer.setAttribute('hidden', '');
      }
    }
  });

  // Initialer Render
  const initialVariantId = el.dataset.variantId;
  console.log('[v2] initialVariantId:', initialVariantId);
  if (initialVariantId) updateDisplay(initialVariantId);

  // Variantenwechsel
  document.addEventListener('variant:changed', (e) => {
    const variant = e?.detail?.variant;
    if (!variant) return;

    el.dataset.variantId = variant.id;

    updateVariantLabel(variant);
    updateDisplay(variant.id);
  });

  // Fallback
  const variantInput =
    document.querySelector('input[name="id"]') ||
    document.querySelector('select[name="id"]');
  if (variantInput) {
    variantInput.addEventListener('change', (e) => updateDisplay(e.target.value));
  }

  // Drawer schließen bei Klick außerhalb
  document.addEventListener('click', (e) => {
    if (!drawer.contains(e.target) && !e.target.closest('#ShowPickupAvailabilityDrawer')) {
      if (typeof drawer.hide === 'function') {
        drawer.hide();
      } else {
        drawer.removeAttribute('open');
        drawer.setAttribute('hidden', '');
      }
    }
  });

})();
